import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { PAGE_SIZES } from "./useTablePrefs";

const TablePagination = ({ page, pageSize, total, onPage, onPageSize }) => {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min(total, (page + 1) * pageSize);

  return (
    <div className="ds-pagination">
      <label className="ds-pagesize">
        Ανά σελίδα
        <select value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))}>
          {PAGE_SIZES.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>
      <span className="ds-range">
        {from}–{to} από {total}
      </span>
      <button
        type="button"
        className="ds-icon-btn"
        onClick={() => onPage(page - 1)}
        disabled={page <= 0}
        aria-label="Προηγούμενη σελίδα"
        title="Προηγούμενη σελίδα ( [ )"
      >
        <ChevronLeftIcon aria-hidden="true" />
      </button>
      <button
        type="button"
        className="ds-icon-btn"
        onClick={() => onPage(page + 1)}
        disabled={page >= pageCount - 1}
        aria-label="Επόμενη σελίδα"
        title="Επόμενη σελίδα ( ] )"
      >
        <ChevronRightIcon aria-hidden="true" />
      </button>
    </div>
  );
};

export default TablePagination;
